import React, { useEffect, useRef, createElement } from 'react';
import { HeaderBar } from './components/HeaderBar';
import { HeroSection } from './components/HeroSection';
import { Section1Origin } from './components/Section1Origin';
import { Section3Question } from './components/Section3Question';
import { Section4Temple } from './components/Section4Temple';
import { Section5Witnessed } from './components/Section5Witnessed';
import { CTAFinal } from './components/CTAFinal';
import { InstituteLegalFooter } from './components/InstituteLegalFooter';
export function App() {
  const ctaRef = useRef<HTMLDivElement>(null);
  const widgetsLoadedRef = useRef(false);
  useEffect(() => {
    document.title = 'Reporte Especial Nº 0039 | Investigación Espiritual';
    // Google Tag Manager
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-5RKW4LTG');`;
    document.head.insertBefore(gtmScript, document.head.firstChild);
    // Google Tag Manager (noscript)
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-5RKW4LTG';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
  }, []);
  // Load SmartTarget + Tawk.to only when CTAFinal section becomes visible
  useEffect(() => {
    const el = ctaRef.current;
    if (!el) return;
    const loadWidgets = () => {
      if (widgetsLoadedRef.current) return;
      widgetsLoadedRef.current = true;
      // SmartTarget WhatsApp button
      const smartScript = document.createElement('script');
      smartScript.type = 'text/javascript';
      smartScript.src = 'https://smartarget.online/loader.js?u=d4b17f89128d601376cfa61bc95e1f7ce48138a5';
      smartScript.async = true;
      document.body.appendChild(smartScript);
      // Tawk.to Live Chat
      const tawkScript = document.createElement('script');
      tawkScript.type = 'text/javascript';
      tawkScript.async = true;
      tawkScript.src = 'https://embed.tawk.to/661c6dd91ec1082f04e23daa/1hrfgq6lh';
      tawkScript.charset = 'UTF-8';
      tawkScript.setAttribute('crossorigin', '*');
      document.head.appendChild(tawkScript);
    };
    // Primary: IntersectionObserver with generous margin for mobile
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        loadWidgets();
        observer.disconnect();
      }
    }, {
      threshold: 0,
      rootMargin: '300px'
    });
    observer.observe(el);
    // Fallback for mobile Safari: check on scroll
    const onScroll = () => {
      if (widgetsLoadedRef.current) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight + 300) {
        loadWidgets();
        window.removeEventListener('scroll', onScroll);
        observer.disconnect();
      }
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', onScroll);
    };
  }, []);
  return <main className="min-h-screen w-full bg-[#f8f9fa] font-sans text-navy-900 selection:bg-gold-500 selection:text-white" data-id="element-0">
      <HeaderBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <Section1Origin data-id="element-3" />

      <Section3Question data-id="element-4" />
      <Section4Temple data-id="element-5" />
      <Section5Witnessed data-id="element-6" />
      <div ref={ctaRef} data-id="element-7">
        <CTAFinal data-id="element-8" />
      </div>
      <InstituteLegalFooter data-id="element-9" />
    </main>;
}